// Angular
import { Component, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { tap } from 'rxjs/operators';

// Afidium
import { IFieldSpecs } from '../interfaces/field-specs';
import { ChipsInputComponent, IAutocompleteItem } from './chipsInput.component';


/**
 * @description
 * Chips Component : Generate chips based on form-field and p-chips (primeNg)
 */
@Component({

    selector: 'chips',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [options]="fieldConfig"
                    [attr.class]="fieldConfig.className">
            <chips-input
                    #input
                    [name]="fieldConfig.formControlName"
                    [formControlName]="fieldConfig.formControlName"
                    [toUpper]="toUpper"
                    [disableFreeText]="disableFreeText"
                    [autocompleteList]="filteredAutocompleteList"
                    [placeholder]="fieldConfig.placeholder"
                    (onAdd)="setFilterAutocompleteList($event)"
                    (onChangeInput)="inputChanged($event)"></chips-input>
        </form-field>
    `,
    styles: [`
        p-chipstab ::ng-deep .ui-inputtext {
            min-height: 1.7em;
            padding: 0.15em 0em;
        }

        p-chipstab ::ng-deep .ui-chips-input-token {
            padding: 5px;
        }
    `]
})
export class ChipsComponent implements OnChanges {

    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public toUpper: boolean;

    @Input()
    public disableDoublonSelection: boolean = true;

    @Input()
    public disableFreeText: boolean = false;

    @Input()
    public autocompleteList: IAutocompleteItem[] = null;

    @Output()
    public readonly onChangeInput: EventEmitter<string> = new EventEmitter();

    @ViewChild('input')
    public input: ChipsInputComponent;

    public filteredAutocompleteList: IAutocompleteItem[];

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.autocompleteList && simpleChanges.autocompleteList.currentValue) {
            this.filteredAutocompleteList = simpleChanges.autocompleteList.currentValue;
            if (this.disableDoublonSelection) {
                this.fieldConfig.formGroup
                    .get(this.fieldConfig.formControlName)
                    .valueChanges
                    .subscribe({
                        next: (chipsValue: string[]): void => {
                            this.setFilterAutocompleteList(chipsValue || []);
                        }
                    });
            }
        }
    }


    public focus(): void {
        this.input.focus();
    }

    public inputChanged(value: string): void {
        this.onChangeInput.emit(value);
    }

    public setFilterAutocompleteList(existingValues: string[]): void {
        if (this.disableDoublonSelection) {
            if (!existingValues.length) {
                this.filteredAutocompleteList = this.autocompleteList;
            } else {
                const existingValuesSet: Set<string> = new Set(existingValues);
                this.filteredAutocompleteList = (this.autocompleteList || [])
                    .filter((autocompleteItem: IAutocompleteItem) => !existingValuesSet.has(autocompleteItem.value));
            }
        }
    }
}
